import React, { useEffect, useState } from 'react'
import injectSheet from 'react-jss'
import { apiClient } from 'pobble-components/dist/api'
import { Image } from 'pobble-components/dist/image'
import Button from 'pobble-components/dist/button'
import MoreButton from 'pobble-components/dist/more-button'
import DropMenu from 'pobble-components/dist/drop-menu'
import { useHistory, Link } from 'react-router-dom'
import { Modal, ModalContent, ModalFooter } from 'pobble-components/dist/modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons/faTrashAlt'
import {
  PARENT_CARD,
  PARENT_FILTER_ACTIVE,
  PARENT_PAGE_BG,
  PARENT_PAGE_HEADER,
  PARENT_PRIMARY_CTA
} from './parent-theme'
import searching from './illustrations/pobble-home-choose-an-image.png'
import writing from './illustrations/pobble-home-discuss-the-image.png'
import posthog from 'posthog-js'
import Spinner from 'pobble-components/dist/spinner'
import { ParentWritingWorkModal } from './parent-writing-work-modal'

const PARENT_WRITINGS_INCLUDE =
  'parent_writing.presentation,parent_writing.presentation.image,parent_writing.presentation.names,parent_writing.presentation.details,parent_writing.presentation.slides,parent_writing.presentation.slide.type,parent_writing.presentation.slide.details,parent_writing.last_parent_writing_work_version.details,parent_writing.last_parent_writing_work_version.work,parent_writing.last_parent_writing_work_version.work.media,parent_writing.last_parent_writing_work_version.work.medium.image,parent_writing.last_parent_writing_work_version.work.medium.details,parent_writing.last_parent_writing_work_version.typed_body,parent_writing.last_parent_writing_work_version.typed_body_cache'
const STATUS_FILTERS = ['all', 'saved', 'started', 'done']

export const ParentLessons = injectSheet({
  container: {
    minHeight: 'calc(100vh - 80px)',
    background: PARENT_PAGE_BG,
    color: 'var(--gray)',
    padding: '48px 20px 56px',
    '@media (min-width: 1024px)': {
      padding: '72px 56px 88px'
    }
  },
  inner: {
    maxWidth: '1200px',
    margin: '0 auto'
  },
  header: {
    ...PARENT_PAGE_HEADER,
    marginBottom: '36px',
    '& h2': {
      fontSize: '32px'
    },
    '& p': {
      fontSize: '18px',
      lineHeight: '24px'
    }
  },
  filters: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    justifyContent: 'center',
    margin: '0 0 24px'
  },
  filterButton: {
    minWidth: '90px',
    background: '#fff',
    color: '#374151',
    border: '1px solid #d1d5db',
    '&:hover': {
      background: '#f9fafb',
      color: '#111827'
    }
  },
  filterActive: PARENT_FILTER_ACTIVE,
  grid: {
    display: 'grid',
    gap: '16px',
    gridTemplateColumns: '1fr',
    '@media (min-width: 640px)': {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))'
    },
    '@media (min-width: 768px)': {
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))'
    },
    '@media (min-width: 1024px)': {
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))'
    },
    '@media (min-width: 1360px)': {
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))'
    }
  },
  card: {
    ...PARENT_CARD,
    position: 'relative',
    '&:hover': {
      '& $cardMenu': {
        opacity: 1
      }
    }
  },
  imageHolder: {
    background: 'var(--purple--)',
    aspectRatio: '16 / 9',
    position: 'relative'
  },
  cardMenu: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    zIndex: 2,
    opacity: 0,
    transition: 'opacity 0.1s ease-in-out',
    '&:hover': {
      opacity: 1
    },
    '& > button': {
      borderColor: '#fff',
      opacity: 0.5,
      '& svg': {
        color: '#fff !important'
      }
    },
    '& > button:hover': {
      opacity: 1
    }
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  body: {
    padding: '12px',
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  title: {
    margin: '0 0 8px',
    font: 'var(--heading--)',
    fontWeight: 'bold',
    color: 'var(--gray)',
    minHeight: '22px'
  },
  cardDescription: {
    margin: '0 0 12px',
    color: 'var(--gray--)',
    font: 'var(--body)',
    lineHeight: 1.45,
    minHeight: '40px'
  },
  status: {
    margin: '0 0 10px',
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 10px',
    borderRadius: '999px',
    fontSize: '12px',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    width: 'fit-content'
  },
  statusSaved: {
    background: '#fef3c7',
    color: '#92400e'
  },
  statusStarted: {
    background: '#dbeafe',
    color: '#1e40af'
  },
  statusDone: {
    background: '#dcfce7',
    color: '#166534'
  },
  cta: {
    marginTop: 'auto',
    ...PARENT_PRIMARY_CTA
  },
  modalPrimary: PARENT_PRIMARY_CTA,
  modalSecondary: {
    color: '#666 !important',
    '&:hover': {
      color: '#666'
    }
  },
  info: {
    textAlign: 'center',
    color: 'var(--gray--)',
    font: 'var(--body)',
    '& img': {
      display: 'block',
      margin: '0 auto 16px'
    },
    '& a': {
      color: 'var(--purple)',
      fontWeight: 'bold',
      textDecoration: 'underline'
    }
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    padding: '32px 0'
  },
  modalContent: {
    width: '100%',
    maxWidth: '460px',
    textAlign: 'center',
    '& h3': {
      margin: '0 0 10px',
      color: '#111827',
      font: 'var(--heading--)'
    },
    '& p': {
      margin: '0',
      color: '#4b5563',
      font: 'var(--body)'
    }
  }
})(({ classes }) => {
  const history = useHistory()
  const [parentWritings, setParentWritings] = useState(null)
  const [selectedWriting, setSelectedWriting] = useState(null)
  const [writingToDelete, setWritingToDelete] = useState(null)
  const [writingToView, setWritingToView] = useState(null)
  const [startPending, setStartPending] = useState(false)
  const [deletePending, setDeletePending] = useState(false)
  const [statusFilter, setStatusFilter] = useState('all')

  useEffect(() => {
    apiClient
      .get('/v3/me/parent_writings', {
        params: {
          include: PARENT_WRITINGS_INCLUDE
        }
      })
      .then(res => {
        setParentWritings(res.data.parent_writings || [])
      })
      .catch(() => {
        setParentWritings([])
      })
  }, [])

  const closeStartModal = () => {
    if (startPending) return
    setSelectedWriting(null)
  }

  const startWriting = () => {
    if (!selectedWriting) return
    posthog.capture('start parent writing')
    setStartPending(true)
    apiClient
      .put(`/v3/parent_writings/${selectedWriting.id}/start`)
      .then(() => {
        history.push(`/parent/writing/${selectedWriting.id}`)
      })
      .finally(() => {
        setStartPending(false)
      })
  }

  const closeDeleteModal = () => {
    if (deletePending) return
    setWritingToDelete(null)
  }

  const deleteWriting = () => {
    if (!writingToDelete) return

    setDeletePending(true)
    apiClient
      .delete(`/v3/parent_writings/${writingToDelete.id}`)
      .then(() => {
        setParentWritings(
          (parentWritings || []).filter(w => w.id !== writingToDelete.id)
        )
        setWritingToDelete(null)
      })
      .finally(() => {
        setDeletePending(false)
      })
  }

  const filteredWritings =
    parentWritings &&
    parentWritings.filter(parentWriting => {
      if (statusFilter === 'all') return true
      return parentWriting.status === statusFilter
    })

  const getStatusClassName = status => {
    if (status === 'started')
      return `${classes.status} ${classes.statusStarted}`
    if (status === 'done') return `${classes.status} ${classes.statusDone}`
    return `${classes.status} ${classes.statusSaved}`
  }

  return (
    <section className={classes.container}>
      <div className={classes.inner}>
        <header className={classes.header}>
          <h2>Your writing</h2>
          <p>
            Everything you&apos;ve saved is here.<br />Pick up where you left
            off, or celebrate a piece you&apos;ve finished together.
          </p>
        </header>
        <div className={classes.filters}>
          {STATUS_FILTERS.map(filter => (
            <Button
              key={filter}
              className={`${classes.filterButton} ${
                statusFilter === filter ? classes.filterActive : ''
              }`}
              action={() => setStatusFilter(filter)}
              simple
              tall>
              {filter === 'all'
                ? 'All'
                : `${filter.charAt(0).toUpperCase()}${filter.slice(1)}`}
            </Button>
          ))}
        </div>

        {parentWritings === null && (
          <div className={classes.loading}>
            <Spinner />
          </div>
        )}

        {parentWritings &&
          filteredWritings &&
          filteredWritings.length === 0 && (
            <p className={classes.info}>
              <img width="320" height="320" src={searching} alt="Pobble Home" />
              Nothing there yet. <Link to="/parent">Pick a prompt</Link> and see
              where it takes you.
            </p>
          )}

        {filteredWritings &&
          filteredWritings.length > 0 && (
            <div className={classes.grid}>
              {filteredWritings.map(parentWriting => {
                const presentation = parentWriting.presentation
                if (!presentation) return null

                return (
                  <article key={parentWriting.id} className={classes.card}>
                    <div className={classes.imageHolder}>
                      <div className={classes.cardMenu}>
                        <DropMenu
                          placement="bottom-end"
                          button={({ ref, togglePopover }) => (
                            <MoreButton
                              forwardedRef={ref}
                              onClick={togglePopover}
                            />
                          )}>
                          {({ Menu, MenuItem, IconHolder, closePopover }) => (
                            <Menu>
                              <MenuItem
                                onClick={() => {
                                  closePopover()
                                  setWritingToDelete(parentWriting)
                                }}>
                                <IconHolder>
                                  <FontAwesomeIcon icon={faTrashAlt} />
                                </IconHolder>
                                Delete
                              </MenuItem>
                            </Menu>
                          )}
                        </DropMenu>
                      </div>
                      <Image
                        className={classes.image}
                        src={presentation.image && presentation.image.url}
                        alt={presentation.title}
                      />
                    </div>
                    <div className={classes.body}>
                      <span
                        className={getStatusClassName(parentWriting.status)}>
                        {parentWriting.status || 'saved'}
                      </span>
                      <h3 className={classes.title}>{presentation.title}</h3>
                      {!!presentation.slides &&
                        !!presentation.slides[3] &&
                        !!presentation.slides[3].text && (
                          <p className={classes.cardDescription}>
                            {presentation.slides[3].text.slice(0, 64)}...
                          </p>
                        )}
                      {parentWriting.status === 'saved' && (
                        <Button
                          className={classes.cta}
                          action={() => setSelectedWriting(parentWriting)}
                          tall>
                          Start{' '}
                          {parentWriting.writing_type === 'typed'
                            ? 'typing'
                            : 'writing'}
                        </Button>
                      )}
                      {parentWriting.status === 'started' && (
                        <Button
                          className={classes.cta}
                          action={() => {
                            posthog.capture('continue parent writing')
                            return history.push(
                              `/parent/writing/${parentWriting.id}`
                            )
                          }}
                          tall>
                          Continue{' '}
                          {parentWriting.writing_type === 'typed'
                            ? 'typing'
                            : 'writing'}
                        </Button>
                      )}

                      {parentWriting.status === 'done' && (
                        <Button
                          className={classes.cta}
                          action={() => setWritingToView(parentWriting)}
                          tall>
                          See my work
                        </Button>
                      )}
                    </div>
                  </article>
                )
              })}
            </div>
          )}
        <Modal
          isOpen={!!selectedWriting}
          requestClose={closeStartModal}
          closeButton>
          <ModalContent className={classes.modalContent}>
            <h3>Ready to write together?</h3>
            <img width="320" height="320" src={writing} alt="Pobble Home" />
            <p>
              {selectedWriting &&
              selectedWriting.presentation &&
              selectedWriting.presentation.title
                ? `You've chosen "${
                    selectedWriting.presentation.title
                  }". When you're ready, let's write.`
                : "When you're ready, let's write."}
            </p>
          </ModalContent>
          <ModalFooter alignRight childrenGap>
            <Button
              simple
              tall
              action={closeStartModal}
              className={classes.modalSecondary}
              disabled={startPending}>
              Cancel
            </Button>
            <Button
              className={classes.modalPrimary}
              minw
              tall
              pending={startPending}
              action={startWriting}>
              Start writing
            </Button>
          </ModalFooter>
        </Modal>
        <ParentWritingWorkModal
          parentWriting={writingToView}
          isOpen={!!writingToView}
          requestClose={() => setWritingToView(null)}
        />
        <Modal
          isOpen={!!writingToDelete}
          requestClose={closeDeleteModal}
          closeButton>
          <ModalContent className={classes.modalContent}>
            <h3>Delete this writing?</h3>
            <p>
              {writingToDelete &&
              writingToDelete.presentation &&
              writingToDelete.presentation.title
                ? `Are you sure you want to delete "${
                    writingToDelete.presentation.title
                  }"? This cannot be undone.`
                : 'Are you sure you want to delete this parent writing? This cannot be undone.'}
            </p>
          </ModalContent>
          <ModalFooter alignRight childrenGap>
            <Button
              simple
              tall
              className={classes.modalSecondary}
              action={closeDeleteModal}
              disabled={deletePending}>
              Cancel
            </Button>
            <Button
              minw
              danger
              tall
              pending={deletePending}
              action={deleteWriting}>
              Delete
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </section>
  )
})
